module.exports = ".panel-heading.child{font-size:1.0em}\n"